import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../../../widgets/Layout';
import { commonStyles, theme } from '../../../shared/lib/styles';
import { QUIZZES } from '../data/quizzes';
import { getQuizProgress, getStarsFromScore } from '../../../features/quizzes/lib/sessionProgress';

const QuizzesHubPage = () => {
    return (
        <Layout>
            <div style={styles.container}>
                <h1 style={styles.title}>Викторины</h1>
                <Link to="/dashboard" style={styles.backLink}>
                    ← На главную
                </Link>
                <p style={styles.subtitle}>
                    Проверь, что ты запомнил из Аудиопособия. Прогресс сохраняется, пока открыта вкладка.
                </p>

                <div style={styles.grid}>
                    {QUIZZES.map((quiz) => {
                        const progress = getQuizProgress(quiz.id);
                        const stars = progress
                            ? getStarsFromScore(progress.bestScore ?? progress.lastScore ?? 0, progress.total ?? quiz.questions.length)
                            : 0;

                        return (
                            <Link
                                key={quiz.id}
                                to={`/quizzes/${quiz.id}`}
                                style={{ ...styles.card, borderTopColor: quiz.color }}
                            >
                                <div style={styles.cardTop}>
                                    <span style={styles.emoji}>{quiz.emoji}</span>
                                    {progress?.completed && (
                                        <span style={styles.badge}>Пройдено</span>
                                    )}
                                </div>
                                <h2 style={styles.cardTitle}>{quiz.title}</h2>
                                <p style={styles.tagline}>{quiz.tagline}</p>
                                <div style={styles.meta}>
                                    <span>{quiz.duration}</span>
                                    {stars > 0 && (
                                        <span style={styles.cardStars}>
                                            {'⭐'.repeat(stars)}
                                        </span>
                                    )}
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </Layout>
    );
};

const styles = {
    container: commonStyles.container,
    title: commonStyles.title,
    backLink: {
        display: 'inline-block',
        marginBottom: theme.spacing.lg,
        color: theme.colors.primary,
        textDecoration: 'none',
        fontSize: theme.fontSize.sm,
    },
    subtitle: {
        color: theme.colors.textSecondary,
        marginBottom: theme.spacing.xl,
        maxWidth: 560,
        lineHeight: 1.5,
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: theme.spacing.lg,
    },
    card: {
        display: 'block',
        padding: theme.spacing.lg,
        backgroundColor: '#fff',
        borderRadius: theme.borderRadius.xl,
        borderTop: `4px solid`,
        boxShadow: theme.shadows.md,
        textDecoration: 'none',
        color: 'inherit',
        transition: 'transform 0.15s ease',
    },
    cardTop: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: theme.spacing.sm,
    },
    emoji: {
        fontSize: theme.fontSize['3xl'],
    },
    badge: {
        fontSize: theme.fontSize.xs,
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.success,
        backgroundColor: 'rgba(200, 220, 190, 0.65)',
        padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
        borderRadius: '999px',
    },
    cardTitle: {
        fontSize: theme.fontSize.lg,
        fontWeight: theme.fontWeight.bold,
        marginBottom: theme.spacing.xs,
    },
    tagline: {
        fontSize: theme.fontSize.sm,
        color: theme.colors.textSecondary,
        marginBottom: theme.spacing.md,
    },
    meta: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: theme.fontSize.sm,
        color: theme.colors.textSecondary,
    },
    cardStars: {
        letterSpacing: 2,
    },
};

export default QuizzesHubPage;
